import { useEffect, useState } from "react";

import { parseAsArrayOf, parseAsString, useQueryState } from "nuqs";

import { useDebounce } from "@/shared/hooks";

interface UseFilterSearchOptions {
  delay?: number;
  onSearch: (value: string) => void;
}

export const useFilterSearch = ({
  delay = 300,
  onSearch,
}: UseFilterSearchOptions) => {
  const [value, setValue] = useState("");

  const debouncedValue = useDebounce(value, delay);

  useEffect(() => {
    onSearch(debouncedValue);
  }, [debouncedValue, onSearch]);

  return {
    value,
    setValue,
  };
};

export const useFilterPopupValues = ({ label }: { label: string }) => {
  const [values = [], setValues] = useQueryState(
    label,
    parseAsArrayOf(parseAsString),
  );

  const onSelect = (value: string) => {
    setValues((prev) => {
      if (!prev) return [value];

      if (prev.includes(value)) {
        return prev.filter((v) => v !== value);
      }

      return [...prev, value];
    });
  };

  const reset = () => {
    setValues(null);
  };

  return {
    values,
    onSelect,
    reset,
  };
};
